export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 2000
export const REVEAL_TIME_MS = 350
export const WELCOME_INFO_MODAL_MS = 350
export const DISCOURAGE_INAPP_BROWSERS = false
export const ENABLE_MIGRATE_STATS = false
export const BLOWFISH_KEY = 'sughusik#Thq&LG*8es2DsZ$3bw^e'
export const BLOWFISH_IV = '#4XmF^ws'
